import { render, staticRenderFns } from "./EmailVerificationDialog.vue?vue&type=template&id=a863b29e"
import script from "./EmailVerificationDialog.vue?vue&type=script&lang=js"
export * from "./EmailVerificationDialog.vue?vue&type=script&lang=js"
import style0 from "./EmailVerificationDialog.vue?vue&type=style&index=0&id=a863b29e&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports